import { NAME_MAX } from "./tuning.js";
const WORDS = [
    "BEANS", "KELZ", "TOMMO", "PIP", "MOSS", "NOODLE", "GUS", "PICKLE", "DOBBY", "FUZZ",
    "CRUMB", "ZIGGY", "BISCUIT", "WOMBLE", "MUNGO", "TOAST", "SPUD", "NIBS", "BODGE", "SQUISH",
];
/** Generated guest name, BEANS_4471 style. `rand` is injected so the sim never touches Math.random. */
export function guestName(rand = Math.random) {
    const w = WORDS[Math.floor(rand() * WORDS.length)];
    const n = 1000 + Math.floor(rand() * 9000);
    return `${w}_${n}`;
}
/** Length and character clamp for a typed name. Anything else is left alone in v1. */
export function sanitizeName(raw) {
    const s = typeof raw === "string" ? raw : "";
    const cleaned = s.replace(/[^\w \-]/g, "").trim().slice(0, NAME_MAX);
    return cleaned.length >= 2 ? cleaned : guestName();
}
//# sourceMappingURL=names.js.map